import styled from 'styled-components';
import { border, color, layout, space, typography } from 'styled-system';

export const StyledLink = styled.a`
  cursor: ${props => props.cursor || 'pointer'};
  color: inherit;
  white-space: ${({ nowrap }) => (nowrap ? 'nowrap' : '')};

  &&& {
    text-decoration: none;
  }

  &:hover {
    color: ${props => props.hoverColor};
  }

  ${typography}
  ${color}
  ${space}
  ${border}
  ${layout}
`;
